


























import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
//@ts-ignore
import { Picker } from 'emoji-mart-vue'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: { Modal, Picker }
})
export default class EmojiPickerButton extends Vue {
  @Prop({
    default: () => {
    }
  }) pickerAttrs: object

  defaultPickerAttrs = {
    native: true,
    showPreview: false,
    showSearch: false,
    infiniteScroll: false,
    sheetSize: 16,
    emojiSize: 20,
    exclude: [],
    pickerStyles: { height: '250px' }
  }

  emojiPickerAttrs = {
    ...this.defaultPickerAttrs,
    ...this.pickerAttrs
  }

  selectedEmoji(emoji) {
    this.$emit('emoji', emoji)
  }
}

